import { _ } from "../../core/polyglot/polyglot.js";
import AbstractIntegration from "./AbstractIntegration.js";

/**
 * `ManualImportIntegration` is an implementation of `AbstractIntegration`
 * for manual import.
 *
 */
export default class ManualImportIntegration extends AbstractIntegration {
	getName() {
		return _("Manual creation");
	}

	routeName() {
		return "new-client";
	}

	importPath() {
		return this.routeName();
	}

	importerCanUpdateExistingCompany() {
		return false;
	}

	isBeta() {
		return false;
	}

	static getType() {
		return "ManualImportIntegration";
	}
}
